<!-- THIS PAGE IS COPIED AND MODIFIED FROM HAULAGE REPORT -->

<template>
  <div class="Trucking-Report-Main">
     <div class="left-container" :class="[ closeLeftTab ? 'left-tab-close' : '' ]" >
      <div class="arrow-button">
        <img :style="{ transform: `${closeLeftTab && !narrowWindow ? `scaleX(-1)` : (!closeLeftTab && !narrowWindow ? `scaleX(1)` : (closeLeftTab && narrowWindow ? `rotate(90deg) scaleX(-1)` : `rotate(90deg) scaleX(1)`))}` }"
          @click="closeLeftTab = !closeLeftTab" src='https://img.icons8.com/material-rounded/96/000000/double-left.png'>
      </div>
      <div class="refresh-icon" v-if="closeLeftTab">
        <Tooltip style="cursor: pointer" icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png" :position="narrowWindow ? 'left' : 'bottom'"
          :iconSize="30" :yOffset="narrowWindow ? 0 : 30" :xOffset="narrowWindow ? -10 : 0" @click.native="refreshClicked">
          <div slot="tooltipText">
            <div>Report Name: <span :style="{ color: selectedReportName ? '' : 'red' }">{{ selectedReportName ? selectedReportName['Report'] : 'Not Selected' }}</span></div>
            <div>Date Field: <span :style="{ color: selectedDateField ? '' : 'red' }">{{ selectedDateField ? selectedDateField['Date Field'] : 'Not Selected' }}</span></div>
            <div>From: <span :style="{ color: selectedFromDate ? '' : 'red' }">{{ selectedFromDate ? $dateTime.getDateTime(new Date(selectedFromDate), 'yyyy-MM-dd') : 'Not Selected' }}</span></div>
            <div>To: <span :style="{ color: selectedToDate ? '' : 'red' }">{{ selectedToDate ? $dateTime.getDateTime(new Date(selectedToDate), 'yyyy-MM-dd') : 'Not Selected' }}</span></div>
            <div>Shpr/Csgn: <span>{{ selectedShipperConsignee.length > 0 ? selectedShipperConsignee.map((shipperConsignee) => { return shipperConsignee["ShprCsgn Code"]; }).join(",") : 'All' }}</span></div>
          </div>
        </Tooltip>
        <!-- <img @click="refreshClicked" title="Click to Refresh" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png" alt=""> -->
      </div>
      <div class="left-container-content" :style="{ display: closeLeftTab ? 'none' : '' }">
        <div>
          <button @click="refreshClicked">Refresh</button>

          <Dropdown class="dropdown" :items="itemReportName" itemKey="Report" :selectedObject.sync="selectedReportName" textAlign="left" placeholder="Report Name" :isRequired="true" :errorMessage.sync="errorReportName"/>

          <Dropdown v-if="showDateField" class="dropdown" :items="itemDateField" itemKey="Date Field" placeholder="Date Field" textAlign="left" :isRequired="true" :selectedObject.sync="selectedDateField" :errorMessage.sync="errorDateField"/> 

          <DateTimePicker v-if="showFrom" class="datetimepicker" placeholder="From" :value.sync="selectedFromDate" :showTime="false" :isDisable="false" :isRequired="true" :errorMessage.sync="fromDateError"/>

          <DateTimePicker v-if="showTo" class="datetimepicker" placeholder="To" :value.sync="selectedToDate" :showTime="false" :isDisabled="false" :isRequired="true" :errorMessage.sync="toDateError"/>

          <Dropdown v-if="showTripStatus" :items="tripStatusList" itemKey="Status" :selectedObject.sync="selectedTripStatus" textAlign="left" placeholder="Trip Status" :isRequired="false"/>
        </div>
        <div v-if="showShipCons">
          <Filters class="filters" title="Shipper / Consignee" :tableData="shipperConsigneeList" itemKey="ShprCsgn Code" itemDesc="ShprCsgn Name" :selectedObject.sync="selectedShipperConsignee" />
        </div>
        <div v-if="showDriver">
          <Filters class="filters" title="Driver" :tableData="driverList" itemKey="Driver Code" itemDesc="Name" :selectedObject.sync="selectedDriver" />
        </div>
      </div>
    </div>
    <div class="right-container">
      <div class="upper-section">
        <div class="left-side">

           <div class="filtered-content">
            <div class="filtered-title">
              Report Name
            </div>
            <div class="filtered-colon">
              :
            </div>
            <div class="filtered-result">
              {{injectedReportName}}
            </div>
          </div>

          <div v-if="showDateField" class="filtered-content">
            <div class="filtered-title">
              Date Field
            </div>
            <div class="filtered-colon">
              :
            </div>
            <div class="filtered-result">
              {{injectedDateField}}
            </div>
          </div>

          <div v-if="showFrom" class="filtered-content">
            <div class="filtered-title">
              From {{injectedDateField}}
            </div>
            <div class="filtered-colon">
              :
            </div>
            <div class="filtered-result">
              {{injectedFromDate}}
            </div>
          </div>

          <div v-if="showTo" class="filtered-content">
            <div class="filtered-title">
               To {{injectedDateField}}
            </div>
            <div class="filtered-colon" >
              :
            </div>
            <div class="filtered-result">
              {{injectedToDate}}
            </div>
          </div>

          <div v-if="showTripStatus" class="filtered-content">
            <div class="filtered-title">
               Trip Status
            </div>
            <div class="filtered-colon" >
              :
            </div>
            <div class="filtered-result">
              {{injectedTripStatus}}
            </div>
          </div>

          <div v-if="showShipCons" class="filtered-content">
            <div class="filtered-title">
               Shipper / Consignee
            </div>
            <div class="filtered-colon" >
              :
            </div>
            <div class="filtered-result">
              {{injectedShipperConsignee}}
            </div>
          </div>

          <div v-if="showDriver" class="filtered-content">
            <div class="filtered-title">
               Driver
            </div>
            <div class="filtered-colon" >
              :
            </div>
            <div class="filtered-result">
              {{injectedDriver}}
            </div>
          </div>

        </div>
        <div class="right-side">
          Last Refreshed : {{lastRefreshed}} 
        </div>
      </div>
      <div class="lower-section"> 
        <TableBox  class=table-box :title="injectedReportName" :tableData="tripData" :loading="tableLoading" :hideColumns="columnsHide" :maxSelection="0"
          :dataType="columnsDataType" :columnOrderViews.sync="tableBoxColumnOrderViews" :columnOrderID="tableBoxColumnOrderID"/>
      </div>
    </div>
    <Loader :isVisible="loading" :loadingText="loadingText" :isFullScreen="true"/>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  computed: {
  },
  data: function() {
    return {
      // set true to close left tab
      closeLeftTab : false,
      // last refresh time on top right
      lastRefreshed : null,
      // data for dropdown
      itemReportName  : [],
      selectedReportName : null,
      injectedReportName : 'Report',
      errorReportName : '',
      itemDateField : [],
      selectedDateField : null,
      injectedDateField : '',
      errorDateField : '',    
      // data for datetimepicker components
      selectedFromDate : null,
      injectedFromDate : '',
      fromDateError : '',
      selectedToDate : null,
      injectedToDate : '',
      toDateError : '',
      // data for shipper consignee filter
      shipperConsigneeList : [],
      selectedShipperConsignee : [],
      injectedShipperConsignee : "",
      driverList: [],
      selectedTripStatus : null,
      injectedTripStatus: "",
      tripStatusList: [],
      selectedDriver: [],
      injectedDriver: "",
      // data for tablebox
      tripData : [],
      tableLoading : false,
      columnsHide : [], // unused for now
      columnsDataType: {}, // dataType is returned by the API as row# 0
      tableBoxColumnOrderViews: [],
      tableBoxColumnOrderID: null,
      // data for loader
      loading : false,
      loadingText : '',

      narrowWindow: false,

      showDateField: false,
      showFrom: false,
      showTo: false,
      showTripStatus: false,
      showShipCons: false,
      showDriver: false
    }
  },
  props: {
  },
  methods: {
    errorReportNameCheck : function() {
      if (!this.selectedReportName) {
        this.errorReportName = 'Please choose one input Report Name';
        return true;
      }
      return false;
    },
    errorDateFieldCheck : function() { 
      if (!this.selectedDateField) {
        this.errorDateField = 'Please choose one input date';
        return true;
      }
      return false;
    },
    errorDatePickerCheck : function() {
      if (this.selectedFromDate.getTime() > this.selectedToDate.getTime()) {
        this.fromDateError = 'From Date > To Date';
        this.toDateError = 'From Date > To Date';
        return true;
      }
      return false;
    },
    refreshClicked : async function() {
      
      this.loading = true;
      this.loadingText = 'Refreshing'

      // check the filters whether is correctly selected / blank check
      if (this.errorReportNameCheck() || this.errorDateFieldCheck() || this.errorDatePickerCheck()){
        this.loading = false;
        this.$showAlert('error', 'Filters are incomplete');
        return;
      }

      this.lastRefreshed = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm');
      // injected = reactive strings/object
      this.injectedReportName = this.selectedReportName['Report'];
      this.injectedDateField = this.selectedDateField['Date Field'];
      this.injectedFromDate = this.$dateTime.getDateTime(this.selectedFromDate, 'yyyy-MM-dd');
      this.injectedToDate = this.$dateTime.getDateTime(this.selectedToDate, 'yyyy-MM-dd');
      this.injectedShipperConsignee = this.selectedShipperConsignee.length > 0 ? this.selectedShipperConsignee.map((shipperConsignee) => { return shipperConsignee["ShprCsgn Code"]; }).join(",") : 'All';
      this.injectedDriver = this.selectedDriver.length > 0 ? this.selectedDriver.map((d) => { return d['Driver Code']; }).join(',') : 'All';
      this.injectedTripStatus = this.selectedTripStatus ? this.selectedTripStatus['Status'] : 'ALL';
      this.loading = false;
      this.tableLoading = true;
      this.tableBoxColumnOrderViews = [];
      this.tableBoxColumnOrderID = null;

      let postJSON = {
        "startdate": this.injectedFromDate,
        "enddate": this.injectedToDate,
        "datetype": this.injectedDateField,
        "reportname": this.injectedReportName,
        "shprcsgnarray": this.selectedShipperConsignee.length > 0 ? `${this.selectedShipperConsignee.map((shipperConsignee) => {return shipperConsignee["ShprCsgn Code"];}).join(",")}` : "",
        "drvarray": this.selectedDriver.length > 0 ? `${this.selectedDriver.map((d) => {return d['Driver Code'];}).join(',')}` : ''
      }

      this.tripData = []; // clear tablebox data

      const columnOrderID = {
        formname: "Haulage_HaulageReport",
        formctrlname: this.injectedReportName,
      }

      let apiRet =  await this.$apiCallV2('/TruckingReport/GetTruckingReport',postJSON, null, null, {message : `{{errorMessage}}`});
      this.tableBoxColumnOrderViews = await this.$apiCallV2('/TableBox/GetColumnOrder', columnOrderID);
      
      if (apiRet.length == 0) { // if the API returned no data
        this.tableLoading = false;
        return;
      }

      this.$nextTick(() => {
        this.tripData = apiRet;
        this.tableLoading = false;
      });
      this.tableBoxColumnOrderID = columnOrderID;

    },
    windowResize: function() {
      this.narrowWindow = window.innerWidth < 900;
    },
  },
  async mounted() {

    this.narrowWindow = window.innerWidth < 900;
    this.loading = true;
    this.loadingText = 'Mounting in';

    this.closeLeftTab = false;
    // default refresh datetime on mounted
    this.lastRefreshed = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm');

    // default from Date and to Date to beginning of the month to end of the month
    var date = new Date();
    this.selectedFromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.selectedToDate = new Date(date.getFullYear(), date.getMonth() + 1, 0); 

    this.loadingText = 'Getting Report Type...'
    this.itemReportName = await this.$apiCallV2(`/TruckingReport/GetListMaster?masterfile=RPT_REPORT&module=TMS`);
    this.selectedReportName = this.itemReportName[0];

    this.loadingText = 'Getting Date Field...'
    this.itemDateField = await this.$apiCallV2(`/TruckingReport/GetListMaster?masterfile=RPT_REPORT_DATEFIELD&module=TMS`);
    this.selectedDateField = this.itemDateField[0];

    this.loadingText = 'Getting Shipper Consignee'
    this.shipperConsigneeList = await this.$apiCallV2(`/TruckingReport/GetListMaster?masterfile=SHPRCSGNNAME`);
  
    this.loadingText = 'Getting Driver'
    this.driverList = await this.$apiCallV2(`/TruckingReport/GetListMaster?masterfile=TMSDriver`);

    this.loadingText = 'Getting Trip Status'
    this.tripStatusList = await this.$apiCallV2(`/TruckingReport/GetListMaster?masterfile=RPT_TRIPSTATUS`);
    let defaultTripStatus = this.tripStatusList.find(a => a['Status'] == 'ALL');
    this.selectedTripStatus = defaultTripStatus;
    this.injectedTripStatus = defaultTripStatus['Status'];
    this.loading = false;

    window.addEventListener('resize', this.windowResize);
  },
  watch: {
    selectedReportName: function(val) {
      if (this.selectedReportName) {
        this.showDateField = this.selectedReportName['Date Field'] == '0' ? false : true;
        this.showFrom = this.selectedReportName['From'] == '0' ? false : true;
        this.showTo = this.selectedReportName['To'] == '0' ? false : true;
        this.showTripStatus = this.selectedReportName['TripStatus'] == "0" ? false : true;
        this.showShipCons = this.selectedReportName['ShipCons'] == '0' ? false : true;
        this.showDriver = this.selectedReportName['Driver'] == '0' ? false : true;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResize);
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.Trucking-Report-Main{
  font-size: 12px;
  width: 200px;
  height :100%;
  padding : 10px 45px;
  display: flex;
  overflow: hidden;

  > .left-container{
    border-radius : 5px;
    max-width: 200px;
    width: 100%;
    background-color: white;
    margin-right: 5px;
    height: 100%;
    transition: 0.3s;

    > .arrow-button{
      width: 100%;
      padding : 7px 4px 50px 0px;
      display: flex;
      justify-content: flex-end;

      > img{
        height: 30px;
        width: 30px;
        padding: 2px;
        z-index: 1;
        transform: scale(1);
        transition: 0.3s;
        cursor: pointer;

        // same as > img :hover {}
        &:hover { 
          border-radius: 50%;
          background-color: rgba(0,0,0,0.5) ;
          transition: 0.3s ease;
        }
      }
    }

    > .refresh-icon{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top : 5px;
      cursor: pointer;
    }

    > .left-container-content{
      background-color: white;
      width: 100%;
      height: 350px;
      display: flex;
      flex-direction: column;
      //justify-content: space-around;
      align-items: flex-start;
      padding-left: 5px;

      > div {
        width: 100%;

        > button {
          width: 90%;
          margin-left: 5px;
          margin-bottom: 10px;
        }

        > .dropdown{
          width: 95%;
          margin-bottom: 10px;
        }

        > .datetimepicker {
          margin-bottom: 10px;
        }

        > .filters {
          height: 200px;
        }
      }
    }
  }

  > .left-tab-close {
    max-width: 40px;
  }

  > .right-container{
    border-radius : 5px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    > .upper-section{
      width: 100%;
      border-radius: 5px;
      height: fit-content;
      background-color : white;
      margin-bottom: 5px;
      display: flex;
      justify-content : space-between;
      align-items: center;

      > .left-side{
        padding-left: 5px;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-around;

        > .filtered-content{
          display: flex;

          > .filtered-title{
            min-width: 185px;
            max-width: 185px
          }

          > .filtered-colon{
            padding-left: 5px;
            padding-right: 5px;  
          }
        }
      }

      > .right-side{
        padding-right: 5px;
      }
    
    }

    > .lower-section{
      height: calc(100% - 83px);
      width: 100%;
      padding: 5px;
      border-radius: 5px;
      background-color: white;

      > .table-box{
        border-radius: 5px;
      }
    }
  }
}

@media only screen and (max-width: 900px) {
  .Trucking-Report-Main{
    flex-direction: column;

    > .left-container {
      height: 100%;
      max-height: 190px;
      max-width: unset;
      width: 100%;
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-start;
      margin-bottom: 5px;

      > .arrow-button{
        width: 30px;
        padding: 0;

        >img{
          margin-top: 2.5px;
          transform: rotate(90deg);
        }
      }

      > .refresh-icon{
        padding-bottom: 5px;
        padding-right: 5px;
      }

      > .left-container-content {
        width: 100%;
        height: 190px;
        padding-top: 5px;
        align-items: flex-start;
        flex-direction: row;

        > div {

          // > button{
          //   width: fit-content;
          // } 

          // > .dropdown{
          //   width: 40%;
          // }

          > .filters {
            height: 180px;
          }
        }
      }
    }

    > .left-tab-close {
      max-height: 35px;
    }

    > .right-container >.upper-section &.left-side{
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden; 
    }

    > .right-container >.upper-section &.left-side{
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden; 
    }
  }
}
</style>